import React from "react";
import { PasswordResetDoneBody } from "tsi-common-react/src/apps/customer-account/PasswordResetDoneBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetDoneDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetDoneBody {...props} />
    </PageSkeleton>
);
